import React from 'react';
import { Check, Info } from 'lucide-react';
import { dojoData } from '../mock';

const Pricing = () => {
  const { pricing } = dojoData;

  const handleContactRedirect = () => {
    const contactFormElement = document.getElementById('contact-form');
    if (contactFormElement) {
      const headerHeight = 100; // Account for header height
      const elementPosition = contactFormElement.offsetTop - headerHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="pricing" className="section-padding section-dark">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4" style={{ hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>Tarifs</h2>
          <p className="body-large max-w-2xl mx-auto" style={{ color: 'var(--text-on-dark)' }}>
            Toutes les adhésions incluent l'accès aux cours et à la vie du dojo.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {pricing.map((plan, index) => (
            <div 
              key={index} 
              className={`pricing-card ${plan.popular ? 'popular' : ''} p-6 rounded-lg border`}
              style={{ 
                backgroundColor: plan.popular ? 'var(--bg-light)' : 'var(--bg-card-dark)',
                color: plan.popular ? 'var(--text-on-light)' : 'var(--text-on-dark)',
                borderColor: plan.popular ? 'var(--brand-primary)' : 'var(--border-medium)',
                borderWidth: plan.popular ? '2px' : '1px'
              }}
            >
              {/* Plan Header */}
              <div className="mb-6">
                <h3 className="heading-3 mb-3" style={{ color: 'var(--brand-primary)', hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>
                  {plan.name}
                </h3>
                
                {plan.type === 'trial' ? (
                  <div>
                    <span className="text-3xl font-bold" style={{ 
                      color: plan.popular ? 'var(--text-on-light)' : 'var(--text-on-dark)' 
                    }}>
                      {plan.price}
                    </span>
                    <p className="body-small mt-1" style={{ 
                      color: plan.popular ? 'var(--text-secondary-light)' : 'var(--text-secondary-dark)' 
                    }}>{plan.duration}</p>
                  </div>
                ) : (
                  <div>
                    <div className="mb-2">
                      <span className="text-2xl font-bold" style={{ 
                        color: plan.popular ? 'var(--text-on-light)' : 'var(--text-on-dark)' 
                      }}>
                        {plan.basePrice}
                      </span>
                    </div>
                    <div className="text-sm" style={{ 
                      color: plan.popular ? 'var(--text-secondary-light)' : 'var(--text-secondary-dark)' 
                    }}>
                      {plan.quarterlyPrice && <p>ou {plan.quarterlyPrice}</p>}
                      <p className="text-xs mt-1">+ Licence FFAAA: {plan.federationFee}</p>
                    </div>
                  </div>
                )}
              </div>

              {/* Features List */}
              <ul className="space-y-3 mb-6">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start gap-2">
                    <Check 
                      size={16} 
                      className="flex-shrink-0 mt-1"
                      style={{ color: 'var(--brand-primary)' }} 
                    />
                    <span className="body-small" style={{ 
                      color: plan.popular ? 'var(--text-on-light)' : 'var(--text-on-dark)' 
                    }}>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA Button */}
              <button 
                className={plan.popular ? 'btn-primary w-full' : 'btn-secondary w-full'}
                onClick={handleContactRedirect}
              >
                {plan.type === 'trial' ? 'Réserver essai' : 'Nous contacter'}
              </button>
            </div>
          ))}
        </div>

        {/* Important Info */}
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            
            {/* Payment Methods */}
            <div className="card-dark p-6 rounded-lg">
              <h3 className="heading-3 mb-4" style={{ color: 'var(--brand-primary)', hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>
                Modalités d'inscription
              </h3>
              <ul className="space-y-2 body-small" style={{ color: 'var(--text-on-dark)' }}>
                <li>• Possibilités de paiement : Chèques, virements, espèces</li>
                <li>• Certificat médical requis lors de la première inscription</li>
                <li>• Gi (Kimono) nécessaire après les séances d'essai</li>
              </ul>
            </div>

            {/* License Info */}
            <div className="card-dark p-6 rounded-lg border" style={{ borderColor: 'var(--brand-primary)' }}>
              <div className="flex items-center gap-2 mb-3">
                <a href="/faq#cat-5-q-2-quest-ce-que-la-licence-federale"><Info size={20} style={{ color: 'var(--brand-primary)' }} className="flex-shrink-0" /></a>
                <h3 className="heading-3" style={{ color: 'var(--brand-primary)', hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>
                  <a href="/faq#cat-5-q-2-quest-ce-que-la-licence-federale">Licence FFAAA</a> obligatoire
                </h3>
              </div>
              <ul className="space-y-1 body-small" style={{ color: 'var(--text-on-dark)' }}>
                <li>• Adultes: 38€/an</li>
                <li>• Jeunes: 26€/an</li>
                <li>• Assurance et affiliation incluses</li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Pricing;
